import React, { useEffect } from "react";
import { Subscribe } from "unstated";
import { Route, Switch } from "react-router-dom";
import { useLocation, useHistory } from "react-router-dom";
import queryString from "query-string";
import { FetchingUserProfile, NotificationsList } from "idc-ui-react";
// Our modules
import { store } from "../../stores/Main";
import {
  AppsPage,
  Dashboard,
  GroupsPage,
  ProfilePage,
  Reports,
  RolesPage,
  AccountPage
} from "../../pages";
import Notifications from "../../components/Notifications";
import onUrlChange from "../../stores/onUrlChange";
// styles
import styles from "./Layout.module.css";

const Layout = ({ store, match }) => {
  const { getLoggedInUser, getInitialData, state } = store;
  const { page, category, action, id } = match.params;
  const location = useLocation();
  const history = useHistory();
  // Make sure the logged in user's profile gets fetched.
  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const firstAttempt = queryString.parse(location.search).firstAttempt;
    if (firstAttempt) {
      queryParams.delete("firstAttempt");
      history.replace({
        search: queryParams.toString()
      });
    }
    getLoggedInUser(firstAttempt === "true");
    getInitialData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getInitialData, getLoggedInUser]);

  useEffect(() => {
    if (action && page === "notifications" && category === "redirect")
      store._redirectFromId(action);
    page === "account" && onUrlChange(store, page, category, action, id);
  }, [page, category, action, store, id]);

  if (!state.loggedInUser.uuid) return <FetchingUserProfile />;

  return (
    <div className={styles.layout}>
      <div className={`${styles.content} ms-Grid`}>
        <NotificationsList
          items={store.state.notifications}
          onDismiss={store.notifications.onDismiss}
        />
        <Switch>
          <Route path="/" exact component={Dashboard} />
          <Route path="/profile" component={ProfilePage} />
          <Route
            path="/:page(reports)/:category?/:action?/:id?"
            component={Reports}
          />
          <Route path="/apps" component={AppsPage} />
          <Route path="/roles" component={RolesPage} />
          <Route path="/groups" component={GroupsPage} />
          <Route path="/account" component={AccountPage} />
          <Route
            path="/notifications/:action?/:id?"
            component={Notifications}
          />
        </Switch>
      </div>
    </div>
  );
};

const StoreWrapper = props => (
  <Subscribe to={[store]}>
    {store => <Layout {...props} store={store} />}
  </Subscribe>
);

export default StoreWrapper;
